import { createActions, handleActions } from 'redux-actions';
import { replace } from 'connected-react-router';
import apiCall from '../api';

const defaultUser = {
  token: null,
  firstName: null,
  lastName: null,
  email: null
};

const savedUser = window.localStorage.getItem('user')
  ? JSON.parse(window.localStorage.getItem('user'))
  : defaultUser;

const defaultState = {
  data: savedUser,
  loading: false,
  error: null
};
const _actions = createActions({
  auth: {
    login: ({ email, password, redirectUrl = '/' } = {}) => async dispatch => {
      dispatch(actions.setLoading({ loading: true, error: null }));
      const result = await apiCall('/login', { args: { email, password } });
      if (!result.success) {
        dispatch(
          actions.setLoading({
            loading: false,
            error: 'Invalid Email/Password'
          })
        );
      } else {
        dispatch(actions.setLoading({ loading: false, error: null }));
        dispatch(actions.setUser(result.payload));
        window.localStorage.setItem('user', JSON.stringify(result.payload));
        dispatch(replace(redirectUrl));
      }
    },
    logout: payload => async dispatch => {
      window.localStorage.removeItem('user');
      dispatch(actions.setUser(defaultUser));
    },
    validate: () => async (dispatch, getState) => {
      if (!getState().auth.data.token) {
        return;
      }

      const result = await apiCall('/validate');
      if (!result.success) {
        dispatch(actions.logout());
      }
      else {
        dispatch(actions.setUser(result.payload));
        window.localStorage.setItem('user', JSON.stringify(result.payload));
      }
    },
    setUser: payload => payload,
    setLoading: payload => payload
  }
});
const actions = _actions.auth;

const setLoading = (state, action) => {
  return Object.assign({}, state, action.payload);
};
const setUser = (state, action) => {
  return Object.assign({}, state, { data: action.payload });
};

const reducer = handleActions(
  {
    [actions.setLoading]: setLoading,
    [actions.setUser]: setUser
  },
  defaultState
);

export { actions, reducer };
